module.exports = __webpack_public_path__ + "img/ai-accompaniment.b989bc1a.jpg";